export default "__VITE_ASSET__xrbpRZ$l__"